<template>
  <div class="ticket-page page-with-tabbar">
    <van-nav-bar 
        title="已出票列表"  
        fixed 
        :placeholder="true"
        left-text="返回"
        left-arrow
        @click-left="goBack"
    />
    <div class="home-wrap">
      <van-pull-refresh v-model="refresh" @refresh="onRefresh">
        <van-list
            v-model="loading"
            :finished="finished"
            finished-text="没有更多了"
            @load="onLoad"
            :immediate-check="false"
        >
          <div class="order-card" v-for="item in tableData" :key="item.order_id" @click="orderDetail(item.order_id)">
            <div class="card-top">
              <div class="top-left">
                <div class="cinema-name">{{ item.cinema_name }}</div>
                <div class="order-row">
                  <span class="order-id">{{ item.order_id }}</span>
                  <span class="copy-btn" @click.stop="copyOrderId(item.order_id)">复制</span>
                </div>
              </div>
              <div class="top-right">
                <span class="status-text">已出票</span>
                <div class="market-price">市场价:￥{{ item.channel_price }}</div>
              </div>
            </div>
            <div class="card-middle">
              <div class="movie-img-box">
                <van-image width="80px" height="100px" fit="cover" :src="item.logo+'_200x200'" />
              </div>
              <div class="movie-info-box">
                <div class="movie-title-row">
                  <div class="movie-title">{{ item.movie_name }}</div>
                  <div class="city-name">{{ item.city_name }}</div>
                </div>
                <div class="showtime-row">
                  <span class="today-tag" v-if="item.play_date_tag">{{ item.play_date_tag }}</span>
                  <span class="showtime">{{ item.play_time_text }}</span>
                </div>
                <div class="hall-name" v-if="item.hall_name">{{ item.hall_name }}</div>
                <div class="movie-tags">
                  <span class="ticket-count">{{ item.quantity }}张</span>
                                          <span v-if="item.seatTag === '2'" class="seat-type-tag couple-seat">情侣座</span>
   
                        <span v-if="item.support_exchange_seat === 'Y'" class="seat-type-tag">九宫格换座</span>
                </div>
                <!-- <div class="seats-info" v-if="item.seats">
                  <span class="seats-text">座位: {{ item.seats }}</span>
                </div> -->
              </div>
            </div>
            <div class="card-bottom">
              <div class="my-bid">已报价:<span style="color: #ff2c54;font-weight: bold;">￥{{ item.my_bid_price }}</span></div>
              <div class="status-info">
                <span class="status-text-green">{{ item.status_text }}</span>
              </div>
            </div>
          </div>
        </van-list>
      </van-pull-refresh>
      <div v-if="tableData.length === 0 && !loading" class="empty-tip">暂无已出票订单</div>
    </div>
  </div>
</template>

<script>
import Api from '@/api-service'
export default {
  name: "Ticket",
  data(){
    return {
      tableData:[],
      queryData:{
        page:1,
        pageSize:10
      },
      loading:false,
      finished:false,
      refresh:false,
    }
  },
  created() {
    console.log('Ticket page created');
    this.fetchData();
  },
  methods:{
    onRefresh(){
      console.log('下拉刷新触发');
      this.queryData.page = 1;
      this.finished = false;
      this.tableData = [];
      this.fetchData();
    },
    fetchData(){
      console.log('fetchData called, page:', this.queryData.page);
      Api.getProcessedOrderList(this.queryData).then(res=>{
        console.log('API response:', res);
        this.loading = false;
        this.refresh = false;
        
        if (res.list && res.list.length > 0) {
          res.list.forEach(item=>{
            this.tableData.push(item);
          });
          
          if(res.list.length < this.queryData.pageSize){
            this.finished = true;
          }
        } else {
          this.finished = true;
        }
      }).catch(res=>{
        console.error('API error:', res);
        this.loading = false;
        this.refresh = false;
      })
    },
    onLoad(){
      console.log('向下滚动加载更多');
      this.queryData.page++;
      this.fetchData();
    },
    orderDetail(id){
      this.$router.push({path:'/order/detail',query:{id:id}})
    },
    goBack() {
      this.$router.go(-1);
    },
    copyOrderId(orderId) {
        if (!orderId) return;
        if (navigator && navigator.clipboard) {
            navigator.clipboard.writeText(orderId).then(() => {
                this.$toast('复制成功');
            });
        } else {
            // 兼容性处理
            const input = document.createElement('input');
            input.value = orderId;
            document.body.appendChild(input);
            input.select();
            document.execCommand('copy');
            document.body.removeChild(input);
            this.$toast('复制成功');
        }
    }
  }
}
</script>

<style scoped lang="scss">
.ticket-page {
  min-height: 100vh;
  background-color: #f7f7fa;
}

.home-wrap {
  padding-top: 15px;
  background-color: #f7f7fa;
  padding-bottom: calc(50px + env(safe-area-inset-bottom, 0px));

  .empty-tip {
    text-align: center;
    color: #888;
    margin-top: 40px;
    font-size: 15px;
  }

  .order-card {
    background: #fff;
    border-radius: 10px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.03);
    margin: 10px 10px 18px 10px;
    padding: 14px 12px 12px 12px;
    display: flex;
    flex-direction: column;

    .card-top {
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      margin-bottom: 8px;

      .top-left {
        flex: 1;
        min-width: 0;
        .cinema-name {
          font-weight: bold;
          font-size: 16px;
          color: #222;
          text-overflow: ellipsis;
          overflow: hidden;
          white-space: nowrap;
          max-width: 100%;
          display: block;
        }

        .order-row {
          display: flex;
          align-items: center;
          font-size: 13px;
          color: #888;
          margin-top: 2px;

          .order-id {
            margin-right: 8px;
          }

          .copy-btn {
            color: #409eff;
            cursor: pointer;
          }
        }
      }

      .top-right {
        text-align: right;

        .status-text {
          color: #52c41a;
          font-size: 14px;
          font-weight: bold;
          display: block;
        }

        .market-price {
          font-size: 13px;
          color: #888;
          margin-top: 2px;
        }
      }
    }

    .card-middle {
      display: flex;
      align-items: flex-start;
      margin-bottom: 8px;

      .movie-img-box {
        width: 80px;
        height: 100px;
        border-radius: 4px;
        margin-right: 12px;
        overflow: hidden;
      }

      .movie-info-box {
        flex: 1;
        min-width: 0;

        .movie-title-row {
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-bottom: 6px;

          .movie-title {
            font-size: 15px;
            font-weight: 500;
            color: #333;
          }

          .city-name {
            font-size: 13px;
            color: #666;
          }
        }

        .showtime-row {
          font-size: 13px;
          color: #333;
          margin-bottom: 6px;
          display: flex;
          align-items: center;
          gap: 6px;

          .today-tag {
            display: inline-block;
            color: white;
            background-color: #ff2c53da;
            font-size: 12px;
            font-weight: bold;
            padding: 2px 6px 2px 4px;
            margin-right: 2px;
            line-height: 1.2;
            vertical-align: middle;
            border-radius: 2px;
          }

          .showtime {
            color: #666;
          }
        }

        .hall-name {
          font-size: 13px;
          color: #888;
          margin-bottom: 4px;
        }

        .movie-tags {
          margin-top: 4px;

          .ticket-count {
            background: #f7f8fa;
            border-radius: 8px;
            font-size: 10px;
            padding: 1px 1px;
            color: #666;
          }

          .seat-type-tag {
            border: 2px solid rgb(0, 140, 255);
            color: rgb(0, 140, 255);
            border-radius: 2px;
            font-size: 10px;
            font-weight: bold;
            padding: 2px 2px;
            margin-left: 4px;
          }
          
          .couple-seat {
            border: 2px solid #ff2c54;
            color: #ff2c54;
            background-color: #fff2f0;
          }
        }

        .seats-info {
          margin-top: 4px;

          .seats-text {
            font-size: 13px;
            color: #666;
          }
        }
      }
    }

    .card-bottom {
      display: flex;
      justify-content: space-between;
      align-items: center;

      .my-bid {
        font-size: 14px;
        color: #666;
      }

      .status-info {
        .status-text-green {
          font-size: 14px;
          color: #52c41a;
          font-weight: bold;
        }
      }
    }
  }
}
</style>
